import React from "react";
import PropTypes from "prop-types";

/**
 * Importing the main stylesheet
 */
import "./Main.css";

/**
 * Main: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Main container component which wrapps the application
 * in an ax-main node.
 *
 * @param {*} props
 */
const Main = props => <div className="ax-main">{props.children}</div>;

Main.propTypes = {
  /**
   * children: React element
   * Child element to render inside main container
   */
  children: PropTypes.element.isRequired
};

export default Main;



// WEBPACK FOOTER //
// ./src/components/main/Main.js